module.exports = __webpack_public_path__ + "static/media/fusk.e35b7014.jpg";